import { Directive, TemplateRef } from '@angular/core'

@Directive({
  selector: '[appGenericTableCellDef]'
})
export class GenericTableCellDefDirective {
  constructor(public readonly template: TemplateRef<unknown>) {}
}
